<template>
    <div>
        <div class="title-bar">
            <div class="volver-atras">
                <DxButton v-bind="backButtonProps()" @click="$router.back()"></DxButton>
                <h1>{{ $t('oscilo_detalle.title') }} {{ oscilo.Nombre }}</h1>
            </div>
        </div>

        <FichaOscilo :osciloProp="oscilo"></FichaOscilo>
        <PestanasOscilo :osciloProp="oscilo"></PestanasOscilo>
    </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import { DxButton } from 'devextreme-vue';
import { onMounted, ref, watch } from 'vue';
import { useApi } from '@/.shared/.api/integration';
import type { OsciloDetalleModel } from '@/.shared/.api';
import { backButtonProps } from '@helpers/button-helper';
import FichaOscilo from '@/components/oscilos/FichaOscilo.vue';
import PestanasOscilo from '@/components/oscilos/PestanasOscilo.vue';

const api = useApi();
const route = useRoute();

const id = ref<number>();
let oscilo = ref<OsciloDetalleModel>({} as OsciloDetalleModel);

onMounted(() => {
    watch(
        () => route.params.id,
        async (newId: string | string[]) => {
            id.value = parseInt(newId as string);

            let osciloDetalle = await api.callStandardApi('osciloGetDetalle', {}, id.value); // Llamada simple;
            oscilo.value = osciloDetalle;
        },
        { immediate: true }
    );
});
</script>

<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";
</style>